import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#F4F4F5"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
    />
    <path
      stroke="#52525B"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m26 16-1 .667-.562.375c-1.604 1.069-2.406 1.603-3.273 1.811a5.001 5.001 0 0 1-2.33 0c-.867-.208-1.669-.742-3.273-1.811L15 16.667 14 16m4 13h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C30 25.2 30 23.8 30 21v-2c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C26.2 11 24.8 11 22 11h-4c-2.8 0-4.2 0-5.27.545a5 5 0 0 0-2.185 2.185C10 14.8 10 16.2 10 19v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C13.8 29 15.2 29 18 29Z"
    />
  </svg>
)
export default SvgComponent
